module.exports = __webpack_public_path__ + "static/media/empty.4aa219b2.svg";